<template>
	<div class="lovelist">
		<header-view :tabsign='3'></header-view>
		<div class="con_tent">
			
			<div class="concar w12 min-h">
				<div class="toptitle">
					<div class="redcon"></div>
					<span>爱心榜</span>
				</div>				
				<div class="right_c">
					<div class="label">捐助查询：</div>
					<div class="screenbox">
						<div class="searchcon">
							<el-input prefix-icon='el-icon-search' class="inputa" size='medium' v-model="searchv" placeholder="实时榜单捐助人"></el-input>
						</div>
					</div>
					<div class="datacon">
						<el-date-picker 
						v-model="donateStartDate"
						type="date"
						size='medium'
						@change='changeStart'
						placeholder="实时捐助开始时间">
						</el-date-picker>
					</div>
					<div class="line_c"></div>
					<div class="datacon">
						<el-date-picker
						v-model="donateStopDate"
						type="date"
						size='medium'
						@change='changeEnd'
						placeholder="实时捐助结束时间">
						</el-date-picker>
					</div>
					<div class="btn_search" @click="searchbtn">查询</div>
				</div>
				<div class="rankdonate">
					<div class="l_rank">
						<div class="top_tit">五大类计划</div>
						<div class="donate_tit">
							<div class="title"></div>
							<div class="screenbtn">
								<div :class="curr == 0?'btn_cur':'btn'" @click="weekFun">近一周</div>
								<div :class="curr == 1?'btn_cur':'btn'" @click="monthFun">近一月</div>
								<div :class="curr == 2?'btn_cur':'btn'" @click="yearFun">近一年</div>
							</div>
						</div>
						<div class="chart_con">
							<div id="myChart"></div>
						</div>
					</div>
					<div class="r_donate">
						<bodyer-right class="right" ref="mychild"></bodyer-right>
					</div>
				</div>	
				
				<div class="ranktable">
				  <table>
					<th style="text-align: center;">排序</th>
					<th style="text-align: center;">项目名称</th>
					<th style="text-align: center;">实际捐助金额</th>
					<th style="text-align: center;">目标资金</th>
					<th style="text-align: center;">捐助开始时间</th>
					<th style="text-align: center;">捐助结束时间</th>
					<!-- <th style="text-align: center;">备注</th>	       -->
						  
					<tr v-if="list.length > 0" v-for="(item, index) in list" :key="index" @click="goDetail(item)">
					  <td>{{ index + 1 }}</td>
					  <td>
							<label v-if="item.thpDonationActivity != undefined">{{ item.thpDonationActivity.title }}</label>
					  </td>
					  <td>{{ getFormatMoney(item.total) }}</td>
					  <td>
							<label v-if="item.thpDonationActivity != undefined">{{ getFormatMoney(item.thpDonationActivity.targetMoney) }}</label>
					  </td>
					  <td>
							<label v-if="item.thpDonationActivity != undefined">{{ item.thpDonationActivity.startDate }}</label>
					  </td>
					  <td>
							<label v-if="item.thpDonationActivity != undefined">{{ item.thpDonationActivity.endDate }}</label>
					  </td>
					  <!-- <td>
							<label v-if="item.thpDonationActivity != undefined">{{ item.thpDonationActivity.tip }}</label>
					  </td> -->
					  <!-- <td>{{ item.thpDonationActivity.endDate }}</td>
					  <td>{{ item.thpDonationActivity.introduction }}</td> -->
					</tr>
				  </table>			
				</div>
				
			</div>
								
		</div>
				
				
	</div>
	
</template>

<script>

import bodyerRight from "../../com/bodyer-right.vue";
import moment from 'moment'
import { formatMoney } from '@/utils/util'
export default {
  components: {
     bodyerRight
  },
  data: function() {
		return {
		    searchv:"",
			donateStartDate:"",
			donateStopDate:"",
			
			startTime: "",
			endTime: "",
			myChart: "",
			list: [],
			curr: 4,
			
		};
  },
  
  mounted() {
    this.myChart = this.$echarts.init(document.getElementById("myChart"));
    this.curr = 2;
    this.startTime = moment(new Date()).subtract(1, 'years').format('YYYY-MM-DD');
    this.init();
  },
  
  created() {
    this.Cumulative();
  },
  
  methods: {
		goDetail(item){//"/lovelist_detail?id="+item.id
			this.$router.push({ path: "/projectDetails?id="+item.thpDonationActivity.id});
		},
	  	changeStart(e){
			this.donateStartDate = moment(e).subtract(0, 'years').format('YYYY-MM-DD');
			console.log('start',e,this.donateStartDate)
			if(moment(this.donateStopDate).diff(moment(this.donateStartDate),'days')<0){ 
				alert("开始时间不能大于结束时间");
				this.donateStartDate=''
			}
		}, 
		changeEnd(e){
			this.donateStopDate = moment(e).subtract(0, 'years').format('YYYY-MM-DD');
			console.log('end',e,this.donateStopDate)
			if(moment(this.donateStopDate).diff(moment(this.donateStartDate),'days')<0){ 
				alert("开始时间不能大于结束时间");
				this.donateStopDate=''
			}
		},
	    searchbtn(){// this.$refs.mychild.searchclick(this.donateStartDate,this.donateStopDate,this.searchv);
			this.$router.push({
				path: '/lovelist_box', 
				query: {
					searchv:this.searchv,
					donateStartDate:this.donateStartDate,
					donateStopDate:this.donateStopDate,
				} 
			});
		},
		
		init(cycle) {
		  var that = this;
		  this.httpGet("web/statisticsController/getWebDonationHistogram", {
		    startTime: cycle == "created" ? this.day(10) : this.startTime,
		    endTime: this.new_date
		  }).then(res => {
		    console.log(res.result);
		      var xAxis = [];
		      var series = [];
		
		      for (var i in res.result) {
				xAxis[i] = res.result[i].title;
		        series[i] = res.result[i].value;
		      }
			  
		      // 绘制图表
		      that.myChart.setOption({
		        tooltip: {
					formatter:'{b}</br>捐助金额:{c}',
					backgroundColor:'#FDEEEC',
					textStyle: {
						color: '#666666' ,
					},
					
				},
		        xAxis: {
		          axisLine:{ 
					lineStyle: {
						type: "solid",
						color: "#999999",
					},
				  },
				  axisTick:{
					  show:false,
				  },
		          data: xAxis,
		          itemCount: 1, //x轴单屏显示数据的数量，默认为5个
		          scrollShow: true, //新增是否显示滚动条，默认false
		          scrollAlign: "left", //滚动条初始位置
		          gridType: "dashed",
		          boundaryGap: ["5%", "5%"],
				  nameLocation:'end',//坐标轴名称显示位置。
				  // axisLabel : {//坐标轴刻度标签的相关设置。
					 //  interval:0,
					 //  rotate:"0"
				  // }
				    axisLabel : {//坐标轴刻度标签的相关设置。
					   interval:0,
					   rotate:30,
					  formatter : function(params){
						 var newParamsName = "";// 最终拼接成的字符串
							  var paramsNameNumber = params.length;// 实际标签的个数
							  var provideNumber = 8;// 每行能显示的字的个数
							  var rowNumber = Math.ceil(paramsNameNumber / provideNumber);// 换行的话，需要显示几行，向上取整
							  /**
							   * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
							   */
							  // 条件等同于rowNumber>1
							  if (paramsNameNumber > provideNumber) {
								  /** 循环每一行,p表示行 */
								  for (var p = 0; p < rowNumber; p++) {
									  var tempStr = "";// 表示每一次截取的字符串
									  var start = p * provideNumber;// 开始截取的位置
									  var end = start + provideNumber;// 结束截取的位置
									  // 此处特殊处理最后一行的索引值
									  if (p == rowNumber - 1) {
										  // 最后一次不换行
										  tempStr = params.substring(start, paramsNameNumber);
									  } else {
										  // 每一次拼接字符串并换行
										  tempStr = params.substring(start, end) + "\n";
									  }
									  newParamsName += tempStr;// 最终拼成的字符串
								  }
		
							  } else {
								  // 将旧标签的值赋给新标签
								  newParamsName = params;
							  }
							  //将最终的字符串返回
							  return newParamsName
					  }
				  }
				  
		        },
		        yAxis: {
					axisTick:{
						show:false,
					},
					axisLine:{ 
						
						lineStyle: {
							type: "solid",
							color: "#999999",
						},
					},
					splitLine: {
						show: true,
						lineStyle: {
							type: "dashed"
						}
					}
		        },
				
		        series: [
		          {
		            type: "bar",
		            data: series,
		            barWidth: "35",
		          }
		        ],
		        legend: {
		          type: "scroll",
		          orient: "horizontal",
		          y: "top",
		          right: 200,
		          left: 100,
		          top: 1,
		          bottom: 1,
		        },
				// grid:{ 
				// 	tooltip:{ 
				// 		axisPointer:{ 
				// 			lineStyle:{ 
				// 				type:'solid',
				// 				color:'#666666'
				// 			}
				// 		}
				// 	}
				// }
		      });
			  
		    // }
		 
		  });
		 
		},
		Cumulative() {
		  var that = this;
		  this.httpGet("web/donation/thpDonationRecord/getTotalByActivty", {
		    pageNo: 1,
		    pageSize: 10
		  }).then(res => {
		    console.log(res.result.records);
		    that.list = res.result.records;
			
			console.log("长度:"+res.result.records.length);
		  });
		  
		  window.pageYOffset = 0;
		  document.documentElement.scrollTop = 0;
		  document.body.scrollTop = 0;
		},
		// 最近一年
		yearFun() {
		  this.curr = 2;
		  this.startTime = moment(new Date()).subtract(1, 'years').format('YYYY-MM-DD');
		  this.init();
		},
		// 最近一周
		weekFun() {
		  this.curr = 0;
		  this.startTime = moment(new Date()).subtract(1, 'weeks').format('YYYY-MM-DD');
		  this.init();
		},
		// 最近一月
		monthFun() {
		  this.curr = 1;
		  console.log("this.curr:"+this.curr);
		  this.startTime = moment(new Date()).subtract(1, 'months').format('YYYY-MM-DD');
		  this.init();
		},
		getFormatMoney(money){
			return formatMoney(money,0)
		},
  },
  
  
  
};
</script>

<style scoped="scoped" lang="scss">
th,
td,
tr,
table {
  margin: auto;
  padding: 0;
}
	
.lovelist{
	
	.con_tent{
		display: flex;
		justify-content: center;
	}
	.concar {
		background: #ffffff;
		margin-top: 100px;
		.toptitle{
			padding: 30px 0px 10px;
			// border-bottom: 1px solid #ededed;
			display: flex;
			align-items: center;
			font-size:25px;
			font-weight: 400;
			color: #E61F26;
			.redcon{
				width:5px;
				height: 20px;
				background: #E70012;
				margin-right: 20px;
			}
		}
		.right_c{
			display: flex;
			align-items: center;
			padding: 10px 0px;
			.datacon{
				.el-input__inner{ 
					width: 220px;
					height:40px!important;
					line-height:40px!important;
				}
			}
			.line_c{
				width:20px;
				height: 2px;
				background: #E5E5E5;
				margin-left:20px;
				margin-right:20px;
			}
			.screenbox{ 
				display: flex;
				justify-content: center;
				align-content: center;
				align-items: center;
				.searchcon{
					height: 40px;
					line-height: 40px;
					width: 319px;
					margin-right: 20px;
					display: flex;
					align-items: center;
					justify-content: space-between;
					.inputa{
						font-size:14px;
					}
					
				}
			}
			.btn_search{ 
				width: 76px;
				height: 43px;
				background: #E41E15;
				border-radius: 4px;
				color: #ffffff;
				font-size: 16px;
				margin-left: 21px;
				display: flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;
			}
		}	
		.rankdonate{
			width:100%;
			display: flex;
			justify-content: space-between;
			height: 411px;
			margin-top: 10px;
			.l_rank{
				border: 1px solid #F4F4F4;
				width: 750px;
				.top_tit{
					width: 100%;
					height:38px;
					line-height:38px;
					background: #E41E15;
					border: 1px solid #E41E15;
					font-size: 18px;
					font-weight: 400;
					color: #FFFFFF;
					padding-left: 10px;
				}
				.donate_tit{
					height: 60px;
					display: flex;
					align-items: center;
					padding-left: 10px;
					justify-content: space-between;
					.title{
						font-size:16px;
						font-weight: 400;
						color: #E41E15;
					}
					.screenbtn{
						display: flex;
						align-items: center;
						position: relative;
						z-index: 10;
						.btn,.btn_cur{
							cursor: pointer;
							margin-right: 20px;
							width:90px;
							height: 25px;
							line-height: 25px;
							text-align: center;
							border-radius:6px;
							font-size: 14px;
							font-weight: 400;
						}
						.btn{
							color: #333333;
							background: #F0E8E8;
						}
						.btn_cur{
							color: #E41E15;
							background: #FFFFFF;
							box-shadow: 0px 1px 4px 0px rgba(230, 31, 38, 0.29);
						}
					}
				}
				.chart_con{
					margin-top: -50px;
					#myChart {
					  width: 100%;
					  height: 350px;
					}
				}
				
			}
		
			.r_donate{
				width: 440px;
			}
		}
		
		.ranktable{
			margin-top: 20px;
			border: 1px solid #F4F4F4;
			width: 100%;
			margin-bottom: 60px;
			table {
			  width: 100%;
			  line-height:54px;
			  border-collapse: collapse;
			  font-size: 16px;
			  font-family: Source Han Sans CN;
			  font-weight: 400;
			  color: #1b1b1b;
			  th,td{
				//   box-shadow: 0px 0px 1px #cccccc;
				border: 1px solid #eeeeee;
				box-sizing: border-box;
			  }
			  th {
				 background: #F9F9F9;
			  }
			  tr {
				color: #666666;
			    background: #ffffff;
				cursor: pointer;
			    td ,label{
			      text-align: center;
				  cursor: pointer;
			    }
			    .act {
			      color: #e61f26;
			    }
			
			    td:last-child {
			    //   border: none;
			    }
			  }
			  tr:last-child {
			    // border: none;
			  }
			}				
		}
		
		
	}
		
	
}

</style>
